import {Component, Input, OnInit, Optional, TemplateRef, ViewChild} from '@angular/core';
import {CustomDataService} from '../../services/custom-data.service';
import {CardService} from '../card/card.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'library-list',
  templateUrl: './library-list.component.html'
})
export class LibraryListComponent implements OnInit {
  items: any[] = []
  constructor(private customDataService: CustomDataService,
              private cardService: CardService,
              private toastr: ToastrService) { }
  @ViewChild('actions') actionsTmp: TemplateRef<any>;

  fileInWay: boolean;
  store: number;
  @Input('store') set $store(value: any) {
    if (value) {
      this.store = value?.id || value;
      this.getData();
    }
  }

  ngOnInit(): void {
    // this.getData();


  }
  ngAfterViewInit() {
    if (this.actionsTmp) {
      this.cardService.setPortal('actions', this.actionsTmp);
    }
  }

  getData() {
    this.customDataService.files({
      filters: {store: this.store}
    }).subscribe(data => {
      this.items = data.array || [];
    })
  }

  openModal() {

  }

  copy($event, item) {
    try {
      const copyText = $event.currentTarget.children.item(1);
      copyText.select();
      document.execCommand("copy");
      item.copied = true;
      setTimeout(() => {
        item.copied = false;
      }, 3000)
    } catch(err) {
      console.log(err);
      alert('Please reload this window')
    }
  }

  upload(event: any) {
    let target = event.target || event.srcElement;
    let files: FileList = target.files;
    if (!files) return;

    let formData: FormData = new FormData();
    formData.append('store', this.store.toString());
    formData.append('file', files[0]);

    this.fileInWay = true;
    this.customDataService.uploadFile(formData).subscribe(data => {
      console.log(data);
      this.items.unshift(data);
      // this.toastr.success('File uploaded!', 'Good job!')
      this.fileInWay = false;
    }, (err) => {

      console.error(err);
      this.fileInWay = false;
    })
  }

  ngOnDestroy() {
    if (this.actionsTmp) {
      this.cardService.clearPortal('actions');
    }
  }

}
